export function formatDateForDisplay(date: Date): string {
    return date.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}